import { useEffect, useRef } from 'react';

// Static variable to track if any ringtone is playing across all hook instances
let isAnyRingtonePlaying = false;

const useCallRingtone = () => {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const isPlayingRef = useRef(false);

  useEffect(() => {
    if (!audioRef.current) {
      const audio = new Audio('/calling-ringtone.mp3');
      audio.loop = true;
      audio.preload = 'auto';
      // Helps iOS/Safari
      // @ts-expect-error playsInline is not in the TS defs for HTMLAudioElement
      audio.playsInline = true;
      audioRef.current = audio;
    }

    // Cleanup on unmount
    return () => {
      stopRingtone();
    };
  }, []);

  const startRingtone = () => {
    // Don't start if another ringtone is already playing
    if (isAnyRingtonePlaying) {
      return;
    }

    const audio = audioRef.current;
    if (audio && audio.paused) {
      audio.play().catch((error) => {
        console.error('Ringtone playback failed:', error);
      });
      isPlayingRef.current = true;
      isAnyRingtonePlaying = true;
    }
  };

  const stopRingtone = () => {
    const audio = audioRef.current;
    if (audio && !audio.paused) {
      audio.pause();
      audio.currentTime = 0;
      isPlayingRef.current = false;
      isAnyRingtonePlaying = false;
    }
  };

  // Cleanup when component unmounts
  useEffect(() => {
    return () => {
      const audio = audioRef.current;
      if (audio) {
        audio.pause();
        audio.currentTime = 0;
        if (isPlayingRef.current) {
          isAnyRingtonePlaying = false;
        }
      }
    };
  }, []);

  return {
    startRingtone,
    stopRingtone,
    isPlaying: isPlayingRef.current
  };
};

export default useCallRingtone; 